import { Term } from "@/components/molecules/Term";
import { Form } from "@/components/organisms/Form";
import { Buttons } from "@/components/atoms/Buttons";
import { agreeState } from "@/common/states/agree";
import { useNavigate } from "react-router";
import { AttendTerms } from "@/data/terms";
import { JoinTemplate } from "@/components/templates/JoinTemplate";
import { InputCheckbox } from "@/components/atoms/Inputs/InputCheckbox";
import { useRecoilState } from "recoil";
import { JoinProcessBar } from "@/components/atoms/JoinProcessBar";

export const AgreeAttendPage = () => {
  const navigate = useNavigate();
  const [agree, setAgree] = useRecoilState(agreeState);
  const isChecked = !!agree?.agreementTime1;

  return (
    <JoinTemplate>
      <Form
        processBar={<JoinProcessBar stepNow={2} stepTotal={6} />}
        title="서비스 이용 안내"
        text={
          <>
            본 서비스 이용을 위해 아래 내용을 읽으신 후
            <br />
            확인 내용에 체크해주시기 바랍니다.
          </>
        }
        submitBtn={
          <Buttons
            type="submit"
            size="lg"
            color="primary100"
            layout="solid"
            label="다음"
            disabled={!isChecked}
            onClick={() => {
              navigate("/auth/join/agree-use");
            }}
          />
        }
        backBtn={
          <Buttons
            type="button"
            size="lg"
            color="primary100"
            layout="text"
            label="뒤로"
            onClick={() => navigate("/auth/join/type")}
          />
        }
      >
        <Term
          processBar={true}
          text={<AttendTerms />}
          checkbox={
            <InputCheckbox
              size="lg"
              name="atend-agree"
              data={[
                {
                  id: 1,
                  value: "",
                  displayExpr:
                    "위의 내용을 모두 확인하였으며, 이에 동의합니다.",
                },
              ]}
              onChange={(e) => {
                setAgree((prev) => ({
                  ...prev,
                  agreementTime1: e.target.checked ? new Date() : null,
                }));
              }}
              value={isChecked}
            />
          }
        />
      </Form>
    </JoinTemplate>
  );
};
